import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { UserService } from '@core/services/user.service';

export function currentUserExistsGuard(urlToRedirect = '/rs-number'): true | UrlTree {
  const userService = inject(UserService);
  const router = inject(Router);

  if (userService.getCurrentUser()) {
    return true;
  }

  return router.parseUrl(urlToRedirect);
}
